@if (field?.props?.label) {
  <div [class.breadcrumb-space]="productConfigurationFacade.isBreadcrumbShown() | async" class="title">
    <h2>{{ props.label }}</h2>
    <div class="tooltip-content">
      <i class="fas fa-question-circle"></i>
      <app-tooltip position="tr">
        <p>{{ 'dental.order_tooth_cross.tooltip' | translate }}</p>
      </app-tooltip>
    </div>
  </div>
}

<div class="tooth-cross-container">
  @if (!readonly) {
    <cap-button
      [styleClass]="
        'secondary short btn-rounded p-button-label-icon-left jaw-selection jaw-selection__upper ' +
        ((toothCrossService.isUpperJawSelected() | async) ? 'jaw-selection--active' : '')
      "
      [label]="
        'order.product_configuration.' +
          ((toothCrossService.isUpperJawSelected() | async) ? 'deselect' : 'select') +
          '_upper_jaw.button' | translateDental
      "
      (onClick)="handleSelectJaw(jawSelection.upperJaw)"
      [disabled]="'upper' | jawStateDisabled | async"
      (mouseenter)="setHoverStateJaw('upper_jaw', true)"
      (mouseleave)="setHoverStateJaw('upper_jaw', false)">
    </cap-button>
  }

  @if (toothCross$ | async; as toothCross) {
    <div [ngClass]="{ 'summary-tooth-cross': readonly && isSummaryPage }" class="tooth-cross">
      @for (group of toothCross.groups; track group) {
        <div class="tooth-cross__part">
          <div class="tooth-cross__part__line">
            @if (selectedTeeth$ | async; as selectedTeeth) {
              @for (tooth of group.teeth; track tooth; let toothIndex = $index) {
                <app-tooth
                  [showRoot]="showRoot$ | async"
                  [tooth]="tooth"
                  [readonly]="readonly"
                  [showHoverEffect]="toothHoverConfig.numbers | inArray: tooth.number"
                  [active]="selectedTeeth | inArray: tooth.number"
                  (mouseenter)="setTeethZoneClasses(tooth.number)"
                  (mouseleave)="toothHoverConfig.numbers = []"
                  (toothPartClick)="onToothSelection(tooth, $event)">
                  @if (selectedTooth?.tooth?.number === tooth?.number && tooth.number === currentRotaryDialTooth) {
                    <app-rotary-dial [buttons]="rotaryDialButtons$ | async" [tooth]="tooth" (closeDial)="closeDial()">
                    </app-rotary-dial>
                  }
                  @if (selectedTooth?.tooth?.number === tooth?.number && (hasCrownActions$ | async)) {
                    <app-crown-actions (closeActions)="closeCrownActions()"> </app-crown-actions>
                  }
                  <app-tooth-connection [tooth]="tooth" [group]="group" [readonly]="readonly" [toothIndex]="toothIndex">
                  </app-tooth-connection>
                </app-tooth>
              }
            }
          </div>
        </div>
      }
    </div>
  }

  @if (!readonly) {
    <cap-button
      [styleClass]="
        'secondary short btn-rounded p-button-label-icon-left jaw-selection jaw-selection__lower ' +
        ((toothCrossService.isLowerJawSelected() | async) ? 'jaw-selection--active' : '')
      "
      [label]="
        'order.product_configuration.' +
          ((toothCrossService.isLowerJawSelected() | async) ? 'deselect' : 'select') +
          '_lower_jaw.button' | translateDental
      "
      (onClick)="handleSelectJaw(jawSelection.lowerJaw)"
      [disabled]="'lower' | jawStateDisabled | async"
      (mouseenter)="setHoverStateJaw('lower_jaw', true)"
      (mouseleave)="setHoverStateJaw('lower_jaw', false)">
    </cap-button>
  }

  @if (isLoading$ | async) {
    <div class="tooth-cross__loading">
      <div class="tooth-cross__loading-overlay"></div>
      <div class="tooth-cross__loading-spinner-container">
        <div class="d-flex spinner">
          <p-progressSpinner></p-progressSpinner>
        </div>
      </div>
    </div>
  }

  @if (toothCrossForm) {
    <cap-validator [control]="toothCrossForm?.controls?.toothCross"></cap-validator>
  }
</div>

<div [hidden]="isSummaryPage" class="sub-tooth-cross">
  <app-form-builder-container
    #mountCheckbox
    class="mount-articular-form"
    formKey="order_tooth_cross_footer_form"
    [defaultValue]="order$.asObservable()"
    [ngClass]="['mount-checkbox', readonly ? 'disabled' : '']">
  </app-form-builder-container>

  <app-form-builder-container
    #toothCrossFooter
    class="tooth-cross-form"
    formKey="order_tooth_cross_form"
    [defaultValue]="order$.asObservable()">
  </app-form-builder-container>
</div>
